module.exports = __webpack_public_path__ + "static/media/neigbourhood.4a61b4c8.svg";